// removed by extract-text-webpack-plugin
module.exports = {"content":"styles__content___3kB3h","defaultSizeLayout":"styles__defaultSizeLayout___IPdAa","maxHeight":"styles__maxHeight___2chaU","containerMenu":"styles__containerMenu___29Lvj","containerSide":"styles__containerSide___1RvhN","containerChildren":"styles__containerChildren___126XC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModernLayout/Main/styles.css
// module id = 2560
// module chunks = 0